// Bump when assessment persistence / scoring behavior changes (one-time reset per tab).
const APPLY_TAB_SESSION_KEY = 'lk_apply_tab_session_v2';

/**
 * First /apply load in this browser tab clears stale persisted assessment data.
 * A refresh keeps the tab session so in-progress answers are not wiped.
 */
export function ensureFreshApplySession(onReset) {
  try {
    if (sessionStorage.getItem(APPLY_TAB_SESSION_KEY) === '1') {
      return false;
    }
    sessionStorage.setItem(APPLY_TAB_SESSION_KEY, '1');
  } catch {
    // sessionStorage blocked — still reset once per mount via caller
  }
  onReset();
  return true;
}

export function clearApplyTabSession() {
  try {
    sessionStorage.removeItem(APPLY_TAB_SESSION_KEY);
  } catch {
    // ignore
  }
}
